import React from 'react';

const SubtramiteContainer = ({ children }) => {
  return (
    <div
      className="bg-white shadow-md rounded-md p-4 max-w-7xl mx-auto"
    >
      {children}
    </div>
  );
}

export default SubtramiteContainer;